import { REDIRECT_URLS_REGEX } from '../components/globals';

export function getLoggedInRedirectUrl(redirectTo: string | undefined): string {
  const hasClientRedirect = redirectTo && redirectTo !== '/';
  if (hasClientRedirect) {
    if (REDIRECT_URLS_REGEX.test(redirectTo)) {
      return redirectTo;
    }
    return `${redirectTo[0] === '/' ? '' : '/'}${redirectTo}`;
  }
  return '/';
}
